import { render, staticRenderFns } from "./currencyList.vue?vue&type=template&id=65114d02&scoped=true&"
import script from "./currencyList.vue?vue&type=script&lang=js&"
export * from "./currencyList.vue?vue&type=script&lang=js&"
import style0 from "./currencyList.vue?vue&type=style&index=0&id=65114d02&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65114d02",
  null
  
)

export default component.exports